import { render } from "./CourseComplete.vue?vue&type=template&id=6d6e85e9&scoped=true"
import script from "./CourseComplete.vue?vue&type=script&lang=js"
export * from "./CourseComplete.vue?vue&type=script&lang=js"

import "./CourseComplete.vue?vue&type=style&index=0&id=6d6e85e9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6e85e9"]])

export default __exports__